'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './sidebar-navigation.component';
import dynamic from 'next/dynamic';

const DynamicSidebarNavigationComponent: ComponentType<Props> = dynamic(
  () => import('./sidebar-navigation.component')
);

export default DynamicSidebarNavigationComponent;

export function calculateSidebarNavigationPlaceholderConfig(): PlaceholderConfig {
  return { heightSinceWidth: [{ sinceWidth: 1024, height: 228 }] };
}
